import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ede6c6f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "footer-box-pc"
};
const _hoisted_2 = {
  class: "centext"
};
const _hoisted_3 = {
  key: 0,
  class: "logoBox"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "iconBox"
};
const _hoisted_6 = {
  class: "tabBox"
};
const _hoisted_7 = {
  class: "tab"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<h3 data-v-ede6c6f0>智能体</h3><p data-v-ede6c6f0><a href=\"/safetyKnowledgeProduct.html\" data-v-ede6c6f0>安全知识类智能体</a></p><p data-v-ede6c6f0><a href=\"/codeSafety.html\" data-v-ede6c6f0>代码安全类智能体</a></p><p data-v-ede6c6f0><a href=\"/codeProduct.html\" data-v-ede6c6f0>无垠模糊测试智能体</a></p><p data-v-ede6c6f0><a href=\"/sastProduct.html\" data-v-ede6c6f0>无暇软件缺陷分析智能体</a></p><p data-v-ede6c6f0><a href=\"/aigcProduct.html\" data-v-ede6c6f0>云起AI安全大脑</a></p><p data-v-ede6c6f0><a href=\"/modelTraining.html\" data-v-ede6c6f0>模型定制化训练框架 </a></p>", 7);
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/consultingService.html"
}, "开发安全咨询服务", -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"tab\" data-v-ede6c6f0><h3 data-v-ede6c6f0>安全服务</h3><p data-v-ede6c6f0><a href=\"/fuzzTest.html\" data-v-ede6c6f0>模糊测试服务</a></p><p data-v-ede6c6f0><a href=\"/safetyTest.html\" data-v-ede6c6f0>安全测试服务</a></p><p data-v-ede6c6f0><a href=\"/confrontationTest.html\" data-v-ede6c6f0>红蓝对抗服务</a></p><p data-v-ede6c6f0><a href=\"/nourishTest.html\" data-v-ede6c6f0>人才培养服务</a></p><p data-v-ede6c6f0><a href=\"/competitionTest.html\" data-v-ede6c6f0>竞赛服务</a></p></div>", 1);
const _hoisted_19 = {
  key: 0,
  class: "tab"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "资源中心", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/corporateBlog.html"
}, "企业博客")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/commonProblem.html"
}, "常见问题")], -1));
const _hoisted_23 = [_hoisted_20, _hoisted_21, _hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab"
}, [/*#__PURE__*/_createElementVNode("h3", null, "关于我们"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=1"
}, "公司简介")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=2"
}, "加入我们")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=3"
}, "联系我们")])], -1));
const _hoisted_25 = {
  key: 1,
  class: "tab"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商务合作", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "010-58171400", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "contact@clouditera.com", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "北京市海淀区盈都大厦", -1));
const _hoisted_30 = [_hoisted_26, _hoisted_27, _hoisted_28, _hoisted_29];
const _hoisted_31 = {
  class: "tab wechart tab-tips"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "联系方式", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：  010-58171400", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "邮箱：  contact@clouditera.com", -1));
const _hoisted_35 = {
  class: "code mr"
};
const _hoisted_36 = ["src"];
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信社群", -1));
const _hoisted_38 = {
  class: "code"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信社群", -1));
const _hoisted_41 = {
  class: "keepRecord"
};
const _hoisted_42 = {
  key: 1,
  class: "footer-box-mobile"
};
const _hoisted_43 = {
  class: "tabBox"
};
const _hoisted_44 = {
  class: "tab"
};
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<h3 data-v-ede6c6f0>智能体</h3><p data-v-ede6c6f0><a href=\"/safetyKnowledgeProduct.html\" data-v-ede6c6f0>安全知识类智能体</a></p><p data-v-ede6c6f0><a href=\"/codeSafety.html\" data-v-ede6c6f0>代码安全类智能体</a></p><p data-v-ede6c6f0><a href=\"/codeProduct.html\" data-v-ede6c6f0>无垠模糊测试智能体</a></p><p data-v-ede6c6f0><a href=\"/sastProduct.html\" data-v-ede6c6f0>无暇软件缺陷分析智能体</a></p><p data-v-ede6c6f0><a href=\"/aigcProduct.html\" data-v-ede6c6f0>云起AI安全大脑</a></p><p data-v-ede6c6f0><a href=\"/modelTraining.html\" data-v-ede6c6f0>模型定制化训练框架 </a></p>", 7);
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/consultingService.html"
}, "开发安全咨询服务", -1));
const _hoisted_54 = [_hoisted_53];
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"tab\" data-v-ede6c6f0><h3 data-v-ede6c6f0>安全服务</h3><p data-v-ede6c6f0><a href=\"/fuzzTest.html\" data-v-ede6c6f0>模糊测试服务</a></p><p data-v-ede6c6f0><a href=\"/safetyTest.html\" data-v-ede6c6f0>安全测试服务</a></p><p data-v-ede6c6f0><a href=\"/confrontationTest.html\" data-v-ede6c6f0>红蓝对抗服务</a></p><p data-v-ede6c6f0><a href=\"/nourishTest.html\" data-v-ede6c6f0>人才培养服务</a></p><p data-v-ede6c6f0><a href=\"/competitionTest.html\" data-v-ede6c6f0>竞赛服务</a></p></div>", 1);
const _hoisted_56 = {
  key: 0,
  class: "tab"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "资源中心", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/corporateBlog.html"
}, "企业博客")], -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/commonProblem.html"
}, "常见问题")], -1));
const _hoisted_60 = [_hoisted_57, _hoisted_58, _hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab"
}, [/*#__PURE__*/_createElementVNode("h3", null, "关于我们"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=1"
}, "公司简介")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=2"
}, "加入我们")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "/aboutUs.html?type=3"
}, "联系我们")])], -1));
const _hoisted_62 = {
  class: "tab tab-tips"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "联系方式", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：  010-58171400", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "邮箱：  contact@clouditera.com", -1));
const _hoisted_66 = {
  class: "code mr"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信社群", -1));
const _hoisted_69 = {
  class: "code"
};
const _hoisted_70 = ["src"];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信社群", -1));
const _hoisted_72 = {
  key: 1,
  class: "tab"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商务合作", -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "010-58171400", -1));
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "contact@clouditera.com", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "北京市海淀区盈都大厦", -1));
const _hoisted_77 = [_hoisted_73, _hoisted_74, _hoisted_75, _hoisted_76];
const _hoisted_78 = {
  key: 0,
  class: "small-logo-box"
};
const _hoisted_79 = {
  class: "tab"
};
const _hoisted_80 = ["src"];
const _hoisted_81 = ["src"];
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createTextVNode(" 关注公众号 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 了解更多内容 ")], -1));
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-contact"
}, [/*#__PURE__*/_createElementVNode("h3", null, "商务合作"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: ""
}, "010-58171400")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: ""
}, "contact@clouditera.com")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: ""
}, "北京市海淀区盈都大厦")])], -1));
const _hoisted_84 = {
  class: "iconBox"
};
const _hoisted_85 = {
  class: "keepRecord"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_float_tab = _resolveComponent("float-tab");
  return _openBlock(), _createElementBlock("div", null, [!_ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [false ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: require('@/assets/img/footer/footerLogo.png'),
    alt: "云起无垠",
    width: "220",
    height: "60"
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
    class: "icon microBlog",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toPage('https://weibo.com/u/7760054991'))
  }), _createElementVNode("i", {
    class: "icon twitter",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.toPage('https://twitter.com/clouditera'))
  }), _createElementVNode("i", {
    class: "icon gitlab",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.toPage('https://github.com/Clouditera'))
  }), _createElementVNode("i", {
    class: "icon zhihu",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.toPage('https://www.zhihu.com/org/yun-qi-wu-yin'))
  })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, false ? (_openBlock(), _createElementBlock("p", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true)]), _hoisted_18, false ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23)) : _createCommentVNode("", true), _hoisted_24, false ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_30)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _hoisted_33, _hoisted_34, _createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
    src: require('@/assets/img/footer/wxCode.png'),
    alt: "",
    width: "128",
    height: "128"
  }, null, 8, _hoisted_36), _hoisted_37]), _createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
    src: require('@/assets/img/footer/clouditeraQrCode.png'),
    alt: "",
    width: "128",
    height: "128"
  }, null, 8, _hoisted_39), _hoisted_40])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("p", null, [_createTextVNode(" Copyright © 2022 | "), _createElementVNode("span", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.toPage('https://beian.miit.gov.cn/#/Integrated/index'))
  }, "京ICP备2022020425号")])])])) : (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, false ? (_openBlock(), _createElementBlock("p", _hoisted_52, _hoisted_54)) : _createCommentVNode("", true)]), _hoisted_55, false ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_60)) : _createCommentVNode("", true), _hoisted_61, _createElementVNode("div", _hoisted_62, [_hoisted_63, _hoisted_64, _hoisted_65, _createElementVNode("div", _hoisted_66, [_createElementVNode("img", {
    src: require('@/assets/img/footer/wxCode.png'),
    alt: "",
    width: "128",
    height: "128"
  }, null, 8, _hoisted_67), _hoisted_68]), _createElementVNode("div", _hoisted_69, [_createElementVNode("img", {
    src: require('@/assets/img/footer/clouditeraQrCode.png'),
    alt: "",
    width: "128",
    height: "128"
  }, null, 8, _hoisted_70), _hoisted_71])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_77)) : _createCommentVNode("", true)]), false ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createElementVNode("img", {
    class: "logo",
    src: require('@/assets/img/footer/mobile-logo.png'),
    alt: "云起无垠logo"
  }, null, 8, _hoisted_80), _createElementVNode("img", {
    class: "QRcode",
    src: require('@/assets/img/footer/QRCode.jpg'),
    alt: "云起无垠公众号"
  }, null, 8, _hoisted_81), _hoisted_82]), _hoisted_83, _createElementVNode("div", _hoisted_84, [_createElementVNode("i", {
    class: "icon microBlog",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.toPage('https://weibo.com/u/7760054991'))
  }), _createElementVNode("i", {
    class: "icon twitter",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.toPage('https://twitter.com/clouditera'))
  }), _createElementVNode("i", {
    class: "icon gitlab",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.toPage('https://github.com/Clouditera'))
  }), _createElementVNode("i", {
    class: "icon zhihu",
    onClick: _cache[8] || (_cache[8] = $event => _ctx.toPage('https://www.zhihu.com/org/yun-qi-wu-yin'))
  })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_85, [_createElementVNode("p", null, [_createTextVNode(" Copyright © 2022 | "), _createElementVNode("span", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.toPage('https://beian.miit.gov.cn/#/Integrated/index'))
  }, "京ICP备2022020425号")])])])), _createVNode(_component_float_tab)]);
}